import { createStructuredSelector } from '@opengov/compose-app/reselect';

import { IReportCreateProps } from '../ReportCreate';

import { selectReportCreateRootProps } from '../ReportCreate/selectors/selectReportCreateRootProps';
import { selectReportCreateDatasetProps } from '../ReportCreateDataset/selectors';
import { selectReportCreateTitleAndDescriptionProps } from '../ReportCreateTitleAndDescription/selectors';
import { selectReportCreateTypeProps } from '../ReportCreateType/selectors';

export const selectReportCreateRouteProps = createStructuredSelector<any, IReportCreateProps>({
  reportCreateRootProps: selectReportCreateRootProps,
  ReportCreateTitleAndDescriptionProps: selectReportCreateTitleAndDescriptionProps,
  ReportCreateDatasetProps: selectReportCreateDatasetProps,
  ReportCreateTypeProps: selectReportCreateTypeProps
});
